module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "onward-end-date"
  }, [_c('label', {
    staticClass: "onward-end-date__toggle"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": !!_vm.enddate
    },
    on: {
      "change": _vm.onToggle
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.label))])]), _vm._v(" "), (_vm.enddate) ? _c('DateSelector', {
    attrs: {
      "date": _vm.enddate,
      "minDate": _vm.minDate,
      "width100": true
    },
    on: {
      "changed": _vm.onDateChanged
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-610026e6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Calendars/OnwardEndDate.vue
// module id = 1956
// module chunks = 1